/**
 * Lecture des limites rendues par /payments/limits/{peopleUuid}.
 *
 * ColdFusion rend ses clés en casses variables : chaque champ est lu en
 * camelCase, minuscules et majuscules.
 */

const lire = (o, nom) => o?.[nom] ?? o?.[nom.toLowerCase()] ?? o?.[nom.toUpperCase()];

/** Le nom d'un profil ou d'un abonnement dans la langue courante (repli : français, puis code). */
export function nomLocalise(objet, langue) {
    if (!objet) return '';
    const l = String(langue || 'fr').slice(0, 2).toLowerCase();
    return lire(objet, `name_${l}`) || lire(objet, 'name_fr') || lire(objet, 'code') || '';
}

/** Une limite normalisée : { limitCode, max, current, periodUnit, periodCount, pourcentage, atteinte }. */
export function normaliserLimite(brute) {
    const max = Number(lire(brute, 'max'));
    const current = Number(lire(brute, 'current')) || 0;
    const periodUnit = String(lire(brute, 'periodUnit') || '').toLowerCase();
    const periodCount = Number(lire(brute, 'periodCount')) || 1;
    const borne = Number.isFinite(max) && max >= 0;
    return {
        limitCode: lire(brute, 'limitCode') || '',
        max: borne ? max : null,
        current,
        periodUnit,
        periodCount,
        pourcentage: borne && max > 0 ? Math.min(100, Math.round((current / max) * 100)) : (borne ? 100 : 0),
        atteinte: borne && current >= max
    };
}

/** Les limites d'un module (liste vide = aucune limite). */
export function limitesDuModule(vue, codeModule) {
    const modules = lire(vue, 'modules') || [];
    const code = String(codeModule || '').toUpperCase();
    const m = modules.find((x) => String(lire(x, 'code')).toUpperCase() === code);
    return (lire(m, 'limits') || []).map(normaliserLimite);
}

/** « sur les 1 dernières semaines » : la clé de traduction de la fenêtre glissante, ou null pour un total. */
export function cleFenetre(periodUnit) {
    return { day: 'windowDay', week: 'windowWeek', month: 'windowMonth', year: 'windowYear' }[periodUnit] || null;
}
